import React, { useContext } from "react";
import "./PageFour.scss";
import { BuildingsContext } from "../../../bContext";

function PageFour() {
   const { switchToEnglish} = useContext(
    BuildingsContext
  );
  return (
    <>
      <div className="pageFour">
        <div className="speech-bubble4">
          {switchToEnglish === false ? (
            <p className="first">
              Za pomocą tych dwóch przycisków możesz ściszyć lub pogłośnić
              lektora oraz muzykę.
            </p>
          ) : (
            <p className="first">
              With these two buttons, you can adjust the volume.
            </p>
          )}
          <div className="inner-triangle-right4"></div>
        </div>
        <div className="menu-pg4"></div>

        <div>
          <div className="modal-header-ins"></div>
          <div className="modalbtn"></div>
          <div className="defaultbtn"></div>
        </div>
      </div>
    </>
  );
}

export default PageFour;
